import { Info, PictureAsPdfOutlined } from '@mui/icons-material';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import EnhancedTable from 'lib/designSystem/Table';
import React from 'react';

import CustomButton from '../../../../../../../../lib/designSystem/Button';

interface DteStatusDialogProps {
  open: boolean;
  onClose: () => void;
  data: {
    folio: string;
    stakeholderIdentifier: string;
    response: string;
    link: string;
  }[];
}

const DteStatusDialog: React.FC<DteStatusDialogProps> = ({
  open,
  onClose,
  data,
}) => {
  const handleClose = () => {
    onClose();
  };

  const openInvoiceLink = async (id: any) => {
    try {
      const row = data.find((item: any) => item.id === id);
      if (!row) return;

      window.open(row.link, '_blank');
    } catch (error) {
      console.log(error);
      return 'Error al obtener el estado del documento';
    }
  };

  const handleOpenLink = {
    key: '',
    label: 'Descargar',
    handleAction: openInvoiceLink,
    icon: <PictureAsPdfOutlined />,
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          Estado de Documentos
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <EnhancedTable
            data={data}
            dataHeaders={[
              { key: 'folio', label: 'Folio' },
              { key: 'response', label: 'Respuesta SII' },
              { key: 'status', label: 'Estado', type: 'status' },
              handleOpenLink,
            ]}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={handleClose}>
          Cerrar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DteStatusDialog;
